import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Navbar.css";
import logo from "../assets/logo.png";
import MultiPurposePDF from "../pdf/Fleet_List-Multi.pdf";
import CarTruck from "../pdf/Fleet_List-PCC.pdf";


const CustomNavbar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [expanded, setExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  // Close menu when route changes
  useEffect(() => {
    setExpanded(false);
    setActiveDropdown(null);
  }, [location.pathname]);
  
  // Function to check if a path is active
  const isActive = (path) => {
    if (path === '/') {
      return activeLink === '/';
    }
    return activeLink.startsWith(path);
  };
  
  // Function to toggle dropdown visibility
  const toggleDropdown = (dropdownName) => {
    if (activeDropdown === dropdownName) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownName);
    }
  };

  // Close menu when clicking a link
  const handleLinkClick = () => {
    setExpanded(false);
    setActiveDropdown(null);
  };

  // Toggle hamburger menu
  const toggleMenu = () => {
    setExpanded(!expanded);
    setActiveDropdown(null);
  };

  return (
    <div className="navbar-container">
      {/* Top section with logo and company name */}
      <div className="navbar-top">
        <div className="container">
          <div className="logo-container">
            <Link to="/" className="navbar-brand" onClick={handleLinkClick}>
              <img src={logo} alt="ECL Logo" className="navbar-logo" />
              <span className="company-name">ECL Shipping India Pvt Ltd</span>
            </Link>
          </div>
          <div className="contact-links">
            <Link 
              to="/contact-us" 
              className={`contact-link ${activeLink === '/contact-us' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <i className="fas fa-phone-alt"></i> Contact Us
            </Link>
            <Link 
              to="/careers" 
              className={`contact-link ${activeLink === '/careers' ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <i className="fas fa-briefcase"></i> Careers
            </Link>
          </div>
        </div>
      </div>

      {/* Main navigation bar */}
      <div className="main-navbar">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-dark">
            <button 
              className="navbar-toggler" 
              type="button" 
              onClick={toggleMenu}
              aria-expanded={expanded}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`}>
              <ul className="navbar-nav">
                {/* Home */}
                <li className="nav-item">
                  <Link 
                    to="/" 
                    className={`nav-link ${isActive('/') ? "active" : ""}`}
                    onClick={handleLinkClick}
                  >
                    Home
                  </Link>
                </li>
                
                {/* About Us Dropdown */}
                <li className={`nav-item dropdown ${activeDropdown === 'about' ? 'show' : ''}`}>
                  <span 
                    className={`nav-link dropdown-toggle ${
                      isActive('/overview') || 
                      isActive('/management-standards-vision') || 
                      isActive('/joint-venture-partners') || 
                      isActive('/statistics') ? "active" : ""
                    }`}
                    role="button" 
                    onClick={() => toggleDropdown('about')}
                  >
                    About Us
                  </span>
                  <ul className={`dropdown-menu ${activeDropdown === 'about' ? 'show' : ''}`}>
                    <li>
                      <Link 
                        to="/overview" 
                        className={`dropdown-item ${isActive('/overview') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Overview
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/management-standards-vision" 
                        className={`dropdown-item ${isActive('/management-standards-vision') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Management & Standards Vision
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/joint-venture-partners" 
                        className={`dropdown-item ${isActive('/joint-venture-partners') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Joint Venture Partners
                      </Link>
                    </li>
                    <li>
                      {/* <Link 
                        to="/statistics" 
                        className={`dropdown-item ${isActive('/statistics') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Statistics
                      </Link> */}
                    </li>
                  </ul>
                </li>
                
                {/* Services Dropdown */}
                <li className={`nav-item dropdown ${activeDropdown === 'services' ? 'show' : ''}`}>
                  <span 
                    className={`nav-link dropdown-toggle ${
                      isActive('/map') || 
                      isActive('/cargoes') || 
                      isActive('/inland-logistics') ? "active" : ""
                    }`}
                    role="button" 
                    onClick={() => toggleDropdown('services')}
                  >
                    Services
                  </span>
                  <ul className={`dropdown-menu ${activeDropdown === 'services' ? 'show' : ''}`}>
                    <li>
                      <Link 
                        to="/map" 
                        className={`dropdown-item ${isActive('/map') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Map
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/cargoes" 
                        className={`dropdown-item ${isActive('/cargoes') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Cargoes
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/inland-logistics" 
                        className={`dropdown-item ${isActive('/inland-logistics') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Inland Logistics
                      </Link>
                    </li>
                  </ul>
                </li>
                
                {/* Sailing Schedule Dropdown */}
                <li className={`nav-item dropdown ${activeDropdown === 'sailing' ? 'show' : ''}`}>
                  <span 
                    className={`nav-link dropdown-toggle ${
                      isActive('/west-east-bound') || 
                      isActive('/intra-asia') ? "active" : ""
                    }`}
                    role="button" 
                    onClick={() => toggleDropdown('sailing')}
                  >
                    Sailing Schedule
                  </span>
                  <ul className={`dropdown-menu ${activeDropdown === 'sailing' ? 'show' : ''}`}>
                    <li>
                      <Link 
                        to="/west-east-bound" 
                        className={`dropdown-item ${isActive('/west-east-bound') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        West East Bound
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/intra-asia" 
                        className={`dropdown-item ${isActive('/intra-asia') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Intra Asia
                      </Link>
                    </li>
                  </ul>
                </li>
                
                {/* Vessels Dropdown */}
                <li className={`nav-item dropdown ${activeDropdown === 'vessels' ? 'show' : ''}`}>
                  <span 
                    className={`nav-link dropdown-toggle ${
                      isActive('/multi-purpose-vessels') || 
                      isActive('/pure-car-truck-carriers') ? "active" : ""
                    }`}
                    role="button" 
                    onClick={() => toggleDropdown('vessels')}
                  >
                    Vessels
                  </span>
                  <ul className={`dropdown-menu ${activeDropdown === 'vessels' ? 'show' : ''}`}>
                    <li>
                      <a
  href={MultiPurposePDF}
  target="_blank"
  rel="noopener noreferrer"
  className={`dropdown-item ${isActive('/multi-purpose-vessels') ? 'active' : ''}`}
  onClick={handleLinkClick}
>
  Multi-Purpose Vessels
</a>

                    </li>
                    <li>
                      <a
                       href={CarTruck}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`dropdown-item ${isActive('/pure-car-truck-carriers') ? 'active' : ''}`}
                        onClick={handleLinkClick}
                      >
                        Pure Car Truck Carriers
                      </a>
                    </li>
                  </ul>
                </li>
                
                {/* Gallery */}
                <li className="nav-item">
                  <Link 
                    to="/gallery" 
                    className={`nav-link ${isActive('/gallery') ? "active" : ""}`}
                    onClick={handleLinkClick}
                  >
                    Gallery
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default CustomNavbar;